// Initialize Swiper
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.mySwiper', {
      slidesPerView: 1, // Show 1 item
      spaceBetween: 30,
      autoplay: {
        delay: 5000, // Auto-slide every 3 seconds
        disableOnInteraction: false, // Continue autoplay after user interaction
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      grabCursor: true, // Enables drag cursor
      allowTouchMove: true, // Ensures draggable
    });
  });
